import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

import en from './en.js'

import cn from './zh-cn.js'

// ===== 应用默认语言（可配置）=====
// 'cn' 简体中文 / 'en' English，按部署区域修改此常量即可
// 用户在头像菜单"切换语言"手动选择后，以 localStorage('app_lang') 记录的选择为准
const DEFAULT_LANG = 'cn'

function resolveLang() {
  const saved = localStorage.getItem('app_lang')
  if (saved === 'cn' || saved === 'en') return saved
  return DEFAULT_LANG
}

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#253c98',
        primaryLight: '#e8ecf5',
        secondary: '#FBC02D',
		third:'#187596',
		four:"#53bee4",
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    }
  },
  lang: {
      locales: { cn, en},
      current: resolveLang(),
   },
});
